<script>
  import Animate from '@ui/pico/animate.svelte';
  import axios from 'axios';
  import { createEventDispatcher, onMount } from 'svelte';
  import { user } from '../../store';

  export let open = false;

  $: form = {
    message: '',
  };

  onMount(() => {
    try {
      const [provider] = $user?.providerData;
      form.email = $user?.email || '';
      form.name = provider?.displayName || '';
    } catch (error) {
      console.warn('help', { message: 'failed to load default user data' });
    }
  });

  let done = false;
  const dispatch = createEventDispatcher();
  async function getHelp() {
    done = true;
    try {
      await axios.post('https://wf.logi.cloud/webforma-alpha-help', form);
    } catch (error) {
      console.warn('Failed to ask for help', { form });
    }
  }

  function close() {
    done = false;
    form = { message: '' };
    dispatch('canceled', { done });
  }
  function closeOnEscape(event) {
    if (event.key === 'Escape') {
      close();
    }
  }
</script>

<svelte:window on:keyup={closeOnEscape} />


<dialog {open}>
  <form on:submit|preventDefault={getHelp}>
    {#if !done}
      <Animate name="slideInUp">
        <article>
          <hgroup>
            <h2>Help</h2>
            <h4>Ask anything. We're here to help!</h4>
          </hgroup>

          <div>
            <div class="grid">
              <label for="name">
                Name
                <input type="text" name="name" bind:value={form.name} />
              </label>
            </div>
            <div class="grid">
              <label for="email">
                Email
                <input type="email" name="email" bind:value={form.email} />
              </label>
            </div>
            <div class="grid">
              <label for="message">
                Message
                <textarea bind:value={form.message} />
              </label>
            </div>
          </div>
          <footer>
            <div class="grid">
              <input
                type="button"
                value="Cancel"
                class="secondary"
                on:click={close}
              />
              <input type="submit" value="Get Help!" class="primary" />
            </div>
          </footer>
        </article>
      </Animate>
    {:else}
      <Animate name="slideDownIn">
        <article>
          <hgroup>
            <h2>Thank you!</h2>
            <h4>
              A Webforma Alpha Team Member will reach out to you shortly if
              required.
            </h4>
          </hgroup>

          <div>
            <div class="grid">
              <label for="name">
                Name
                <input
                  type="text"
                  name="name"
                  bind:value={form.name}
                  disabled
                />
              </label>
            </div>
            <div class="grid">
              <label for="email">
                Email
                <input
                  type="email"
                  name="email"
                  bind:value={form.email}
                  disabled
                />
              </label>
            </div>
            <div class="grid">
              <label for="message">
                Message
                <textarea bind:value={form.message} disabled />
              </label>
            </div>
          </div>
          <footer>
            <div class="grid">
              <input
                type="button"
                value="Exit"
                class="secondary"
                on:click={close}
              />
            </div>
          </footer>
        </article>
      </Animate>
    {/if}
  </form>
</dialog>

<style>
  footer {
    margin-top: 0;
  }
</style>
